





















































import Vue from 'vue'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import { Meta } from '@/tools/page'

const PAGE_TITLE = '会社概要'
const PAGE_META: Meta[] = [
  {
    name: 'description',
    content:
      '1チケットフィットネスサービスGYYM(ジーム)の運営会社に関する情報です。',
  },
]

export default Vue.extend({
  components: {
    PageDefaultLayout,
  },
  created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)
  },
})
